import React, { useCallback, useMemo, memo } from 'react';

import {
    DeleteOutlined, EyeOutlined, DownloadOutlined,
} from '@ant-design/icons';
import { Popconfirm } from 'antd';

import { imageTypesRegex, getPreviewByType } from '~/helpers/storage-helper';

import ImgLoading from '../ImgLoading';
import styles from './UploadItem.module.scss';

const UploadItem = memo(({
    onPreview, onRemove,
    onDownload,
    file, width, height,
}) => {
    const handleRemove = useCallback(() => {
        onRemove(file);
    }, [file, onRemove]);

    const handlePreview = useCallback(() => {
        onPreview(file);
    }, [file, onPreview]);

    const handleDownload = useCallback(() => {
        onDownload(file);
    }, [file, onDownload]);

    const sizeStyle = useMemo(() => ({ width, height }), [width, height]);

    const renderDonwloadPreviewButton = () => {
        if (imageTypesRegex.test(file.type)) {
            return (
                <EyeOutlined
                    onClick={handlePreview}
                    className={styles.icon}
                    title="Visualizar"
                />
            );
        }
        return (
            <DownloadOutlined
                onClick={handleDownload}
                className={styles.icon}
                title="Baixar"
            />
        );
    };

    const renderImage = () => {
        const urlImage = imageTypesRegex.test(file.type)
            ? (file.urlPreview || file.url)
            : getPreviewByType(file.type);

        return (
            <ImgLoading
                src={urlImage}
                alt={file.name}
                className={styles.image}
                style={sizeStyle}
            />
        );
    };

    return (
        <div className={styles.container} style={sizeStyle}>
            {renderImage()}

            <div className={styles.content} style={sizeStyle}>
                <div className={styles.buttonsContainer}>
                    {renderDonwloadPreviewButton()}

                    <Popconfirm
                        title={(
                            <span>
                                Deseja excluir o arquivo
                                {' '}
                                <strong>
                                    {file.name}
                                </strong>
                                ?
                            </span>
                        )}
                        onConfirm={handleRemove}
                        okText="Excluir"
                        cancelText="Voltar"
                        placement="topLeft"
                    >
                        <DeleteOutlined
                            className={styles.icon}
                            title="Excluir"
                        />
                    </Popconfirm>
                </div>
            </div>
        </div>
    );
});

export default UploadItem;
